import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const rocheListTextItemCss = ":host{display:block;margin-top:3rem;margin-top:0;display:inline-block}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}@media (min-width: 64rem){:host{margin-top:0}}";
const RocheListTextItemStyle0 = rocheListTextItemCss;

const RocheListTextItem$1 = /*@__PURE__*/ proxyCustomElement(class RocheListTextItem extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.text = undefined;
    }
    render() {
        return (h(Host, { key: '002701cf290690f51c623aa693b059506acb046c' }, h("div", { key: '787b5501c3c3a5da583f5bae82c24425cdd6f0c3' }, this.text), h("slot", { key: '4c3e4fa0cf9365beec231112a334a3a95db216e6', name: "list" })));
    }
    static get style() { return RocheListTextItemStyle0; }
}, [1, "roche-list-text-item", {
        "text": [1]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-list-text-item"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-list-text-item":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheListTextItem$1);
            }
            break;
    } });
}

const RocheListTextItem = RocheListTextItem$1;
const defineCustomElement = defineCustomElement$1;

export { RocheListTextItem, defineCustomElement };

//# sourceMappingURL=roche-list-text-item.js.map